import { ORIGIN_IDENTIFIER as individualOriginIdentifier } from './application/variants/individual/registration/constants/selection_process'
import { ORIGIN_IDENTIFIER as mentorOriginIdentifier } from './application/variants/mentor/registration/constants/selection_process'
import { ORIGIN_IDENTIFIER as reportAOriginIdentifier } from './application/reports/reporta/registration/constants/selection_process'
import { ORIGIN_IDENTIFIER as reportBOriginIdentifier } from './application/reports/reportb/registration/constants/selection_process'

export const TERMS_OF_USE_URL =
  'https://docs.google.com/document/d/10f3ZFzu_DGjkc1WC6YVDneKmXBXVnAuLyuDsFyG4yBg/'

export const TERMS_OF_USE_URL_INDIVIDUAL = TERMS_OF_USE_URL
export const TERMS_OF_USE_URL_MENTOR = TERMS_OF_USE_URL
export const TERMS_OF_USE_URL_PARTNER = TERMS_OF_USE_URL

export const origins = {
  individualOriginIdentifier,
  mentorOriginIdentifier,
  reportAOriginIdentifier,
  reportBOriginIdentifier,
}

export const originsIdentifiers = Object.values(origins)
